// Generated by Argon compiler — do not edit by hand.
// CSR store output: reactive shared state with no runtime dependency.

const __argonSubs = new Map();

function __argonNotify(key) {
  for (const fn of __argonSubs.get(key) ?? []) fn();
}

export function argonSubscribe(key, fn) {
  let set = __argonSubs.get(key);
  if (!set) __argonSubs.set(key, set = new Set());
  set.add(fn);
  return () => {
    set.delete(fn);
    if (set.size === 0) __argonSubs.delete(key);
  };
}

export const files = {};
let __argon_files_selected = [];
Object.defineProperty(files, "selected", {
  enumerable: true,
  get() { return __argon_files_selected; },
  set(value) {
    if (Object.is(__argon_files_selected, value)) return;
    __argon_files_selected = value;
    __argonNotify("files.selected");
  },
});

export function argonSnapshot() {
  return {
    files: { selected: files.selected },
  };
}

export function argonHydrate(snapshot) {
  if (!snapshot) return;
  if (snapshot.files) {
    if ("selected" in snapshot.files) files.selected = snapshot.files.selected;
  }
}

const __argonPayload = globalThis.document?.querySelector?.('script[type="application/json"][data-argon-stores]');
if (__argonPayload?.textContent) argonHydrate(JSON.parse(__argonPayload.textContent));
